(function profileDetailControllerDefinition() {
    'use strict';
    angular.module('Profile')
        .controller('ProfileDetailController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'userService', '$stateParams', 'authExtend', 'loginService', 'profileCertificateService',
            function profileDetailController($scope, config, $state, $translate, errors, userService, $stateParams, authExtend, loginService, profileCertificateService) {

                $scope.showImageLoad = authExtend.getOrganizationId() !== '';
                $scope.showCertificates = false;
                $scope.user = {
                    organizationalUnitName: ''
                };

                loginService.getLogged(true)
                    .then(function (result) {
                        $scope.user = result;
                        $scope.user.organizationalUnitName = authExtend.getOrganizationName()
                    }, function (error) {
                        errors.showError(error);
                        $state.go('inicio');
                    });

                $scope.edit = function () {
                    $state.go("edit-profile");
                };

                if (authExtend.isInRole('CERTIFICATE PROFILE READ')) {
                    profileCertificateService.get()
                        .then(function (result) {
                            $scope.certificates = result;
                            $scope.showCertificates = true;
                        }, function (error) {
                            errors.showError(error);
                            $state.go('inicio');
                        });
                }
            }
        ]);
})();